// Headings in title case: every word capitalised except short joining words (unless first).
// All-caps text from Sanity is lowered first; names and acronyms keep their own spelling.
const KEEP = {
  mahima: 'Mahima', bali: 'Bali', ubud: 'Ubud', sayan: 'Sayan', indonesia: 'Indonesia',
  wpt: 'WPT', itf: 'ITF', atp: 'ATP', idr: 'IDR', faq: 'FAQ', pt: 'PT',
}
const MINOR = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with', 'vs'])

export default function titleCase(text = '') {
  let t = String(text).trim()
  if (!t) return t
  if (t === t.toUpperCase()) t = t.toLowerCase()
  let first = true
  return t.replace(/[A-Za-zÀ-ÿ]+/g, (w, offset) => {
    const lower = w.toLowerCase()
    const isFirst = first
    first = false
    if (KEEP[lower]) return KEEP[lower]
    // keep words that already mix capitals (e.g. "Playtomic", "iPhone") as written
    if (w !== lower && w !== w[0] + w.slice(1).toLowerCase() && w !== w.toUpperCase()) return w
    // inside a hyphenated word or after an apostrophe, only capitalise word starts
    const prev = t[offset - 1]
    if (prev === "'" || prev === '’') return lower
    if (!isFirst && MINOR.has(lower) && prev !== '-') return lower
    return lower.charAt(0).toUpperCase() + lower.slice(1)
  })
}
